// Trap 6: one idempotency key per draft. Minted when the draft starts, kept in sessionStorage
// per conversation so a retry after a network blip reuses it, replaced only after a 2xx.

import { uuid } from './format';

const PREFIX = 'bt:idem:';

export function getOrMintKey(conversationId: string): string {
  const k = PREFIX + conversationId;
  try {
    const existing = sessionStorage.getItem(k);
    if (existing) return existing;
    const fresh = uuid();
    sessionStorage.setItem(k, fresh);
    return fresh;
  } catch {
    return uuid();
  }
}

export function clearKey(conversationId: string): void {
  try {
    sessionStorage.removeItem(PREFIX + conversationId);
  } catch {
    /* private mode; nothing to clear */
  }
}

const DRAFT_PREFIX = 'bt:draft:';

export function loadDraft(conversationId: string): string {
  try {
    return sessionStorage.getItem(DRAFT_PREFIX + conversationId) ?? '';
  } catch {
    return '';
  }
}

export function saveDraft(conversationId: string, text: string): void {
  try {
    if (text) sessionStorage.setItem(DRAFT_PREFIX + conversationId, text);
    else sessionStorage.removeItem(DRAFT_PREFIX + conversationId);
  } catch {
    /* ignore */
  }
}
